import { useApolloClient } from '@apollo/client'
import { archiveAttachment, updateAttachment } from '../../../../api'

const useAttachmentMutation = () => {
  const client = useApolloClient()

  const deleteAttachment = (video) => {
    return archiveAttachment(client, video)
  }
  const mutateAttachment = (attachment) => {
    return updateAttachment({ client, attachment })
  }
  return { mutateAttachment, deleteAttachment }
}

export default useAttachmentMutation
